import WidgetModel from '../widget-model'
import ImageView from './image-view'
import scoreboardUrl from 'scoreboard/components/scoreboard-url'

var ImageWidget = WidgetModel.extend({
	viewCls: ImageView,
	rotatable: true,

	containerDefaults: {
		minHeight: minDimension,
		minWidth: minDimension
	},

	defaults: function () {
		return {
			properties: {
				type: 'image'
			}
		}
	},

	getAspectRatio: function () {
		if (this._naturalDimensions) {
			// We use the natural dimensions of the image for determining aspect ratio
			return this._naturalDimensions.height / this._naturalDimensions.width
		} else {
			// An image hasn't been loaded, use the wob properties
			return this.wob.get('height') / this.wob.get('width')
		}
	},

	isInteractive: function () {
		return false
	},

	isClickthrough() {
		return !this.drilldown()
	},

	src: function () {
		var imageId = this.properties.get('imageId')
		var token = this.get('embeddedToken')

		if (this.get('image')) {
			// If the image was just set, it will be a data URI in the widget
			// attributes
			return this.get('image').dataUri
		} else if (this.wob.get('image')) {
			// If this is a dashboard in a form and the image hasn't been saved
			// yet, the image will be a data URI in the wob attributes
			return this.wob.get('image').dataUri
		} else if (imageId) {
			// If the image has been saved, the ID will be in the properties
			var uri = 'api/images/' + imageId
			if (token) {
				// EmbeddableResourceInterceptor and EmbeddableResourceHelper expect
				// shared dashboard resources to have shared/{token} in the URI.
				// which is required to validate the request and identify the right
				// DB for the image
				uri += '/shared/' + token
			}
			return scoreboardUrl(uri)
		}

		return null
	}
})

function minDimension () {
	// Default minimum width/height is 20, but if an image hasn't been set yet,
	// we need to leave enough room for the "upload image" button to fit
	if (this.properties.get('imageId') || this.get('image')) {
		return 20
	}

	// Keep in sync with DashboardsDao.MINIMUM_EMPTY_IMAGE_DIMENSION
	return 200
}

export default ImageWidget

ImageWidget.__filename__ = 'dashboards/widgets/image/image-model.js'
